import React, { useState, useEffect } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Scrollspy from 'react-scrollspy';
import { Menu, X } from 'react-feather';
import styled from 'styled-components';
import { graphql, useStaticQuery, navigate } from 'gatsby';
import Img from 'gatsby-image';
import { FormattedMessage, useIntl } from 'react-intl';

import { Container } from '../../global';
import {
  Nav,
  NavItem,
  Brand,
  StyledContainer,
  NavListWrapper,
  MobileMenu,
  Mobile,
  ActionsContainer,
} from './style';

import { isSalonzone } from '../../../../../utils';

const NAV_ITEMS = [
  { title: <FormattedMessage id="navFeatures" />, scrollTo: 'features' },
  { title: <FormattedMessage id="navPricing" />, scrollTo: 'packages' },
  // { title: <FormattedMessage id="navReferences" />, scrollTo: 'references' },
  { title: <FormattedMessage id="navAboutUs" />, scrollTo: 'aboutUs' },
  { title: <FormattedMessage id="navContact" />, scrollTo: 'contact' },
];

const ImageWrapper = styled.div`
  justify-self: end;
  align-self: center;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    justify-self: center;
  }
`;

const StyledImage = styled(Img)`
  max-height: 68px;
  min-width: 100px;
  max-width: 300px;
`;

const LoginButton = styled.button`
  && {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: ${(props) => props.theme.font_weight.bold};
    margin-left: 4px;
  }
`;

const SignupButton = styled.button`
  && {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: ${(props) => props.theme.font_weight.bold};
    margin-left: 4px;
    background-color: ${(props) => props.theme.color.accent};
    min-width: 148px;
  }
`;

const Navigation = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const { locale } = useIntl();

  const data = useStaticQuery(graphql`
    query {
      file(sourceInstanceName: { eq: "product" }, name: { eq: "logo_big" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      fileSc: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "logo_big_sc" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `);

  const handleScroll = (event) => {
    const scrollTop = window.pageYOffset;

    if (scrollTop > 32) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  };

  const getNavAnchorLink = (item) => (
    <AnchorLink href={`#${item.scrollTo}`} onClick={closeMobileMenu}>
      {item.title}
    </AnchorLink>
  );

  const getNavList = ({ mobile = false }) => (
    <NavListWrapper mobile={mobile}>
      <Scrollspy
        items={NAV_ITEMS.map((item) => item.scrollTo)}
        currentClassName="active"
        mobile={mobile}
        offset={-64}
      >
        {NAV_ITEMS.map((navItem) => (
          <NavItem key={navItem.title}>{getNavAnchorLink(navItem)}</NavItem>
        ))}
      </Scrollspy>
    </NavListWrapper>
  );

  return (
    <Nav {...props} scrolled={hasScrolled}>
      <StyledContainer>
        <Brand>
          <Scrollspy
            offset={-64}
            item={['feliratkozás']}
            currentClassName="active"
          >
            <AnchorLink href="#feliratkozás" onClick={closeMobileMenu}>
              <ImageWrapper>
                <StyledImage
                  style={isSalonzone ? { width: '300px' } : {}}
                  fluid={
                    isSalonzone
                      ? data.fileSc.childImageSharp.fluid
                      : data.file.childImageSharp.fluid
                  }
                />
              </ImageWrapper>
            </AnchorLink>
          </Scrollspy>
        </Brand>
        {!props.logoOnly && (
          <>
            <Mobile>
              <button
                onClick={toggleMobileMenu}
                style={{ color: 'black', background: 'none' }}
              >
                {mobileMenuOpen ? (
                  <X size={24} alt="close menu" />
                ) : (
                  <Menu size={24} alt="open menu" />
                )}
              </button>
            </Mobile>
            <Mobile hide>{getNavList({})}</Mobile>
            <ActionsContainer>
              <LoginButton
                onClick={() => {
                  navigate(`/${locale}/app/login`);
                }}
              >
                <FormattedMessage id="loginButton" />
              </LoginButton>
              <SignupButton
                onClick={() => {
                  navigate(`/${locale}/signup`);
                }}
              >
                <FormattedMessage id="signUp" />
              </SignupButton>
            </ActionsContainer>
            <Mobile>
              {mobileMenuOpen && (
                <MobileMenu>
                  <Container>{getNavList({ mobile: true })}</Container>
                </MobileMenu>
              )}
            </Mobile>
          </>
        )}
      </StyledContainer>
    </Nav>
  );
};
export default Navigation;
